import { DEFAULT_GROUND_TERMINAL_PART_UID, GENESIS_TERMINAL_PART_UID, ROUTE_BRANCH_POINT_PART_UID, ROUTE_BRANCH_POINT_TERMINAL_UID, } from "@buildwithflux/models";
/**
 * @deprecated Use directly from `@buildwithflux/constants` instead
 */
export { DEFAULT_GROUND_TERMINAL_PART_UID, GENESIS_TERMINAL_PART_UID, GENESIS_TERMINAL_TERMINAL_UID, GROUND_PORTAL_PART_TERMINAL_UID, GROUND_PORTAL_PART_UID, GROUND_TERMINAL_UID, OFFICIAL_NET_PORTAL_PART_UID, OFFICIAL_POWER_NET_PORTAL_PART_UID, ROUTE_BRANCH_POINT_PART_UID, ROUTE_BRANCH_POINT_TERMINAL_UID, } from "@buildwithflux/models";
/**
 * @see PartStorageHelper that has similar functions.
 */
export function isSystemPart(partUid) {
    return [
        ROUTE_BRANCH_POINT_TERMINAL_UID,
        ROUTE_BRANCH_POINT_PART_UID,
        GENESIS_TERMINAL_PART_UID,
        DEFAULT_GROUND_TERMINAL_PART_UID,
        // QUESTION: why is the ground portal not included in isSystemPart check?
    ].includes(partUid);
}
//# sourceMappingURL=systemParts.js.map